import { buildSelector } from '@/shared/lib/store';

export const [useViewerIsSocial] = buildSelector(
    (state) => state.viewer?.data?.is_social || false,
);
